export default __webpack_public_path__ + "static/media/facade.67b50b83.svg";